import { render, staticRenderFns } from "./MenuGroup.vue?vue&type=template&id=47dc66c3&scoped=true&"
import script from "./MenuGroup.vue?vue&type=script&lang=js&"
export * from "./MenuGroup.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/menu/MenuGroup/MenuGroupStyle.css?vue&type=style&index=0&id=47dc66c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc66c3",
  null
  
)

export default component.exports